/**
 * Shrimp Zone — offer cooldown logic
 *
 * Pure functions. No DOM, no storage — sz-rd-offer.js owns localStorage and
 * hands the parsed map in, so scripts/verify-offer.mjs can require this file
 * and run the rules directly (the dispatch-logic lesson: pure logic belongs
 * where the prover can run it).
 *
 * Owner rule 2026-08-21: ONE offer per item per 24 hours per customer.
 * localStorage means per BROWSER — a nudge, not a wall. Clearing storage,
 * private mode, or another device resets it; that trade-off was named to the
 * owner before this was built. Bots are hCaptcha's job, not this file's.
 *
 * The clock guard is FAIL-OPEN, the opposite direction to the dispatch
 * timer's: a stamp dated in the future can only mean the clock that wrote it
 * and the clock reading it disagree, and locking a real customer out on a
 * broken clock is worse than letting one extra offer email through.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SZOfferCooldown = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var TTL_MS = 86400000; // 24 hours

  /* Drop expired and future-dated stamps. Returns a NEW map — callers persist
     it, so pruning here is what stops the map growing one key per product
     forever. */
  function prune(map, now) {
    var out = {};
    for (var k in map) {
      if (!Object.prototype.hasOwnProperty.call(map, k)) continue;
      var ts = map[k];
      if (typeof ts !== 'number') continue; // junk survives a JSON.parse; drop it
      if (ts > now) continue;               // future stamp = broken clock, fail open
      if (now - ts >= TTL_MS) continue;     // served its 24 hours
      out[k] = ts;
    }
    return out;
  }

  /* 0 = free to offer; otherwise the epoch-ms when the window reopens. */
  function blockedUntil(map, pid, now) {
    var ts = map ? map[String(pid)] : undefined;
    if (typeof ts !== 'number') return 0;
    if (ts > now) return 0; // fail open on a future stamp
    if (now - ts >= TTL_MS) return 0;
    return ts + TTL_MS;
  }

  /* Stamp pid only when it has no live stamp. Reloading the "offer sent" page
     hours later re-runs the caller, and re-stamping there would quietly extend
     the lock past the 24 hours the owner asked for. */
  function record(map, pid, now) {
    var clean = prune(map || {}, now);
    if (!blockedUntil(clean, pid, now)) clean[String(pid)] = now;
    return clean;
  }

  /* Plain words for the wait, ELI5 rule: no timestamps, no countdown. */
  function waitText(msLeft) {
    if (msLeft <= 3600000) return 'in under an hour';
    var h = Math.ceil(msLeft / 3600000);
    return 'in about ' + h + ' hours';
  }

  return {
    TTL_MS: TTL_MS,
    prune: prune,
    blockedUntil: blockedUntil,
    record: record,
    waitText: waitText,
  };
});
